export const environment = {
    production: false,
    baseDomain: 'ka-boom.app',
    apiUrl: 'https://api.dev.ka-boom.app',
    twilio: {
        // Twilio Voice signalling edge — must match the account/API-key region.
        // Ireland = 'dublin'. See https://www.twilio.com/docs/global-infrastructure/edge-locations
        edge: '',  // '' = Twilio default (US) routing; set e.g. 'dublin' for an Ireland-region account
    },
    auth0: {
        domain: 'ka-boom-dev.uk.auth0.com',
        clientId: 'YgOJY9PCJ3fkPzMaAKlLArd0Ppqcxe4b',
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: 'https://kaboom-logicalapi-ci',
        },
    },
    httpInterceptor: {
        allowedList: [
            // Note: /api/tenants/resolve is intentionally absent — OrgContextService
            // uses HttpBackend directly to bypass this interceptor entirely.
            {
                uri: '/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://kaboom-logicalapi-ci'
                    }
                }
            },
            {
                uri: 'https://api.dev.ka-boom.app/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://kaboom-logicalapi-ci'
                    }
                }
            },
            {
                uri: 'https://api.dev.ka-boom.app/api/v1/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://kaboom-logicalapi-ci'
                    }
                }
            }
        ]
    }
}
